

























import DetictingMobile from "@/mixins/DetictingMobile";
import { message, card, Button, ICard } from '@/utilities/index';
import { PayloadContent } from "@tactful/sdk";
import Flickity from "vue-flickity";
import urlParsing from "@/mixins/urlParsing";
declare global {
    interface Window {
        Flickity: any;
    }
}
interface UrlParams {
    customerToken: string | null;
    productId: string | null;
    lang: string | null;
    profileId: string;
    channelId: string;
    profileName: string;
    userId: string;
}

export default {
    props: ["cards", "isFullScreen", "blankTarget"],
    components: {
        Flickity
    },
    mixins: [DetictingMobile, urlParsing],
    data() {
        return {
            flickityOptions: {
                initialIndex: 0,
                pageDots: true,
                draggable: ">1",
                freeScroll: false,
                cellAlign: "center",
                contain: true,
                prevNextButtons: false,
                imagesLoaded: true,
            },
            isListening: false,
        };
    },
    created() {
        if (this.isFullScreen) {
            this.flickityOptions.pageDots = false;
        }
    },
    computed: {
        channelId() {
            return this.$vstore.settings.state.preferenceSettings.channelId;
        },
        profileId() {
            return this.$vstore.settings.state.preferenceSettings.profileId;
        },
        userId() {
            return this.$vstore.settings.state.preferenceSettings.guid;
        },
        token() {
            return this.$vstore.settings.state.preferenceSettings.token;
        },
        profileName() {
            return this.$vstore.settings.state.preferenceSettings.profile;
        },
    },
    mounted() {
        this.$root.$on("pauseVideo", this.onPuaseVideo);
    },
    methods: {
        isWebviewLink(url: string) {
            // Webview links pattern is `<protocol>://<host>/webchat/<html_page_name>?<query_params>`
            // other external links will not have the /webchat/ route in it
            return url?.includes("/webchat/") ?? false;
        },
        constructRouteParams(button: any) {
            return {
                name: button.target || 'productDetails',
                params: {
                    token: this.token,
                    link: button.url,
                    source: 'webChat',
                    profileName: this.profileName,
                    userId: this.userId,
                    ...this.extractUrlParams(button.url)
                }
            };
        },
        extractUrlParams(url: string): UrlParams {
            let urlParams;
            try {
                urlParams = new URLSearchParams(new URL(url).search);
            }
            catch {
                urlParams = null;
            }
            return {
                customerToken: urlParams?.get("customer_token") || "",
                productId: urlParams?.get("product_id") || null,
                lang: urlParams?.get("language") || "",
                profileId: urlParams?.get("profile_id") || this.profileId,
                channelId: urlParams?.get("channel_id") || this.channelId,
                profileName: urlParams?.get("profile_name") || this.profileName,
                userId: urlParams?.get("user") || this.userId
            };
        },
        cleanText(text: string) {
            return message.cleanText(text);
        },
        showMoreText(desc: string) {
            return card.showMoreText(desc, 70);
        },
        trauncateTitle(currentCard: ICard) {
            return card.trauncateTitle(currentCard);
        },
        onPuaseVideo(isListening: boolean) {
            if (isListening) {
                this.isListening = true;
            }
        },
        getTargetBasedOnSettings(button: Button) {
            if (this.blankTarget) {
                return '_blank';
            }
            else {
                return message.getTarget(button);
            }
        },
        onPostback(payload: PayloadContent, title: string) {
            this.$emit("onPostback", payload, title);
        },
        detectLang(title: string) {
            return message.detectLang(title);
        },
        applyLargeStyles(currentCard: ICard) {
            return card.applyLargeStyles(currentCard);
        },
        mapCardButtonsToComponents(buttons: any[]) {
            const components = [];
            if (!buttons) buttons = [];
            const self = this;

            for (const button of buttons) {
                switch (button.type) {
                    case "phone_number":
                        components.push({
                            render: (h) => {
                                return h('a', { class: "tc--b-widget__carousel--btn" , attrs: { href: `tel:${button.phone_number}`, target: "_top" } }, button.button_title);
                            }
                        });
                        break;
                    case "web_url":
                        if (self.isWebviewLink(button.url)) {
                            components.push({
                                render: (h) => {
                                    return h('router-link', { class: "tc--b-widget__carousel--btn", props: { to: self.constructRouteParams(button) } }, button.button_title);
                                }
                            });
                        }
                        else {
                            components.push({
                                render: (h) => {
                                    return h('a', { class: "tc--b-widget__carousel--btn", attrs: { href: card.getUrl(button), target: self.getTargetBasedOnSettings(button) } }, button.button_title);
                                }
                            });
                        }
                        break;
                    case "postback":
                        components.push({
                            render: (h) => {
                                return h('button', { class: "tc--b-widget__carousel--btn", on: { click: () => self.onPostback(button.payload, button.button_title) } }, button.button_title);
                            }
                        });
                        break;
                    default:
                        break;
                }
            }
            return components;
        }
    }
};
